import { css } from '@emotion/react';
import { useTranslations } from 'next-intl';
import { atoms } from '@zapier/marketing-ui';
import { Icon } from '@zapier/design-system';
import { ClaudeZapierLogos } from './ClaudeZapierLogos';
import { mediaQueries } from '@zapier/identity-utils';

const styles = {
  root: css({
    maxWidth: 480,
    marginBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  }),

  [mediaQueries.desktop]: {
    marginBottom: 0,
    gap: 24,
  },
};

function Feature(props: { children: string }) {
  return (
    <li
      className={`${atoms.bodySM} ${atoms.flex} ${atoms.itemsCenter} ${atoms.gap2}`}
    >
      <Icon name="formCheck" color="BrandOrange" size={20} />
      <span>{props.children}</span>
    </li>
  );
}

export function ClaudeSignUpPromo() {
  const t = useTranslations('claude-signup-promo');

  return (
    <div css={styles.root} className={atoms.textNeutral900}>
      <ClaudeZapierLogos />
      <h3 className={atoms.headingXL}>
        {/* eslint-disable-next-line react/display-name */}
        {t.rich('heading', { br: () => <br /> })}
      </h3>
      <p className={atoms.body}>{t('description')}</p>
      <ul className={`${atoms.flexCol} ${atoms.gap3}`}>
        <Feature>{t('feature-trial')}</Feature>
        <Feature>{t('feature-visibility')}</Feature>
        <Feature>{t('feature-automation')}</Feature>
      </ul>
    </div>
  );
}
